import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ActionSheetController, ModalController } from "@ionic/angular";
import { ViewDocumentDetailModel } from "src/app/model/ViewDocumentDetailModel";
import { ViewApplicationService } from "src/app/services/view-application.service";
import { ViewPdfComponent } from "../../view-pdf/view-pdf.component";
// import { ViewImageComponent } from "../../view-image/view-image.component";
import { ViewImageComponent } from "src/app/secure/applicant-editing-approver-list/view-image-modal/view-image.component";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewProfileDocumentComponent } from "src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component";
import { DocumentVerificationService } from "src/app/services/document-verification.service";
import { Page } from "src/app/model/Page";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { PolDocumentApproveComponent } from "./approve-case/poldocument-approve-case.component";
import { TdsRejectComponent } from "./reject-case/tds-reject-case.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ProApproverService } from "src/app/services/pro-approver.service";
import { ViewImageOnlyComponent } from "../../view-image-only/view-image-only.component";


@Component({
  selector: "app-secure-view-poldocument-dtl",
  templateUrl: "./view-engienrdocument-dtl.component.html",
  styleUrls: ["./view-document-dtl.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ViewEngineeringDocumentDtlComponent implements OnInit {
  data: ViewDocumentDetailModel;
  page: Page<ViewDocumentDetailModel>;
  dataSource: MatTableDataSource<ViewDocumentDetailModel> =
    new MatTableDataSource();
  applicationNo: number;
  submitDisabled: boolean = false;
  isLoading: boolean = false;
  selectedFile: File;
  isSubmitDisabled: boolean = false;
  successMessage: string;
  errorMessage: String;
  errorFile: string;
  loaded: boolean = false;
  @ViewChild('localForm') localForm : NgForm;

  manualRejectedQuestions: any[] = [];
  documents: any[] = [];
  verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  downloadedBatches: string[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  panNumber: string ;
  progressSpinnerDialog: any = null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isSearchDisabled: boolean = false;
  displayedColumns: string[] = [
    "id",
    "installmentType",
    "installmentAmount",
    "delayDays",
    "interestAmount",
    "totalAmountToBePaid",
    "totalwithinterestAmount",
    "settlementAmount",
    "balanceAmount",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  // isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  showtable: number = 5000001;
  source: string;

  constructor(
    private route: ActivatedRoute,
    private documentVerificationService: DocumentVerificationService,
    private proApproverService: ProApproverService,
    private modalCtrl: ModalController,
    private auditTrailService: AuditTrailService,
    private router: Router,
    public actionSheetController: ActionSheetController,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private _snackBar: MatSnackBar,
    private viewApplicationService: ViewApplicationService,
  ) { }

  ngOnInit(): void {
     this.loadData();
  }

  loadData(){
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.source = params["source"];
      console.log("this.applicationNo", this.applicationNo);
      this.isLoading = true;
      this.documentVerificationService
        .fetchBeforePolDetailView(this.applicationNo)
        .subscribe(
          async (data: any) => {
            this.isLoading = false;
            if (data.status === "SUCCESS") {
              this.data = data;
             
            } else {
              this.documentVerificationService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.isLoading = false;
            this.documentVerificationService.errorToast(
              error?.error?.errorMessage || error?.error?.message
            );
          }
        );
      this.documentVerificationService
        .fetchPaymentDetailView(this.applicationNo)
        .subscribe(
          (page: any) => {
            this.isLoading = false;
            console.log("Page ", page);
            this.page = page;
            console.log("fetchPaymentDetailView ", page.content);
            if (page.content !== null && page.content !== "") {
              this.dataSource = new MatTableDataSource(page.content);
              console.log("this.dataSource ", this.page);
            } else {
              this.isLoading = false;
              this.documentVerificationService.errorToast(page.errorMessage);
            }
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = page.totalElements;
            });
            this.isSearchDisabled = false;
          },
          (error) => {
            console.log(error);
            this.isLoading = false;
            this.isSearchDisabled = false;
          }
        );
    });
  }

  showAsFile() {
    asFile: String;
    this.isLoading = true;
    console.log("this.applicationNo", this.applicationNo);
    this.documentVerificationService
      .fetchAsFile("asFile", this.applicationNo)
      .subscribe(async ({ status, data, errorMessage }) => {
        this.isLoading = false;
        if (status === 'SUCCESS') {
          const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
            componentProps: {
              base64: data,
              documentName: "16AS File",
              fileName: "ACKNOWLEDGEMENT_" + this.data?.applicationNo + "_" + new Date().getTime() + ".pdf"
            }
          });
          modal.present();
        }
        else {
          this.documentVerificationService.errorToast(errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.documentVerificationService.errorToast("Unable to fetch As File");
      });
  }


  showForm16BFile() {
    asFile: String;
    this.isLoading = true;
    console.log("this.applicationNo", this.applicationNo);
    this.documentVerificationService
      .fetchForm16BFile("asFile", this.applicationNo)
      .subscribe(async ({ status, data, errorMessage }) => {
        this.isLoading = false;
        if (status === 'SUCCESS') {
          const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
            componentProps: {
              base64: data,
              documentName: "Form16B File",
              fileName: "ACKNOWLEDGEMENT_" + this.data?.applicationNo + "_" + new Date().getTime() + ".pdf"
            }
          });
          modal.present();
        }
        else {
          this.documentVerificationService.errorToast(errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.documentVerificationService.errorToast("Unable to fetch As File");
      });
      
  }

  showQbFile() {
    asFile: String;
    this.isLoading = true;
    console.log("this.applicationNo", this.applicationNo);
    this.documentVerificationService
      .fetchQbFile("asFile", this.applicationNo)
      .subscribe(async ({ status, data, errorMessage }) => {
        this.isLoading = false;

        if (status === 'SUCCESS') {
          const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
            componentProps: {
              base64: data,
              documentName: "Qb File",
              fileName: "ACKNOWLEDGEMENT_" + this.data?.applicationNo + "_" + new Date().getTime() + ".pdf"
            }
          });
          modal.present();
        }
        else {
          this.documentVerificationService.errorToast(errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.documentVerificationService.errorToast("Unable to fetch As File");
      });
  }
   

   async possessions() {
    const modal = await this.modalCtrl.create({
        component: PolDocumentApproveComponent,
        componentProps: {
            pan: "Possessions Receipt",
            applicantName: this.data.applicantName,
            acceptsType: "application/pdf"
        }
    });
    modal.present();
 
    const { data, role } = await modal.onWillDismiss();
   
    if (role === 'approve') {
      this.onSubmit(this.applicationNo,"POSSESSIONS_RECEIPT",data);
    }
  }

  async affidavit() {
    const modal = await this.modalCtrl.create({
        component: PolDocumentApproveComponent,
        componentProps: {
            pan: "Affidavit",
            applicantName: this.data.applicantName,
            acceptsType: "application/pdf"
        }
    });
    modal.present();
 
    const { data, role } = await modal.onWillDismiss();
   
    if (role === 'approve') {
      console.log("affidavit called",data)
      this.onSubmit(this.applicationNo,"AFFIDAVIT",data);
    
    }
  }

  async Keyhandover() {
    const modal = await this.modalCtrl.create({
        component: PolDocumentApproveComponent,
        componentProps: {
            pan: "Key handover Photo",
            applicantName: this.data.applicantName,
            acceptsType: "image/jpeg"
        }
    });
    modal.present();
 
    const { data, role } = await modal.onWillDismiss();
   
    if (role === 'approve') {
      this.onSubmit(this.applicationNo,"KEYHANDOVER",data);
    }

    
  }

   

 

  showChallanfile() {
    asFile: String;
    this.isLoading = true;
    console.log("this.applicationNo", this.applicationNo);
    this.documentVerificationService
      .fetchChallanFile("asFile", this.applicationNo)
      .subscribe(async ({ status, data, errorMessage }) => {
        this.isLoading = false;
        if (status === 'SUCCESS') {
          const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
            componentProps: {
              base64: data,
              documentName: "Challan File",
              fileName: "ACKNOWLEDGEMENT_" + this.data?.applicationNo + "_" + new Date().getTime() + ".pdf"
            }
          });
          modal.present();
        }
        else {
          this.documentVerificationService.errorToast(errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.documentVerificationService.errorToast("Unable to fetch As File");
      });
  }

  statusFiles(status: any) {
    if(!this.data.form16bFile){
      return this._snackBar.open("FORM16B file is required", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "warning-toast",
        duration: 3 * 1000,
      })
    }
    this.isLoading = true;
    this.documentVerificationService.statusFile(
      status, this.applicationNo.toString()
    ).subscribe((data) => {
      this.isLoading = false;
      this.loadData();
      console.log(data, 'fromStatus files API');
         this._snackBar.open("TDS Certificate Approved", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "success-toast",
          duration: 3 * 1000,
        })})
      }


      showAcknowledgement() {
        console.log(this.data?.registrationId, 'RegistrationId');
        console.log(this.data?.applicationId, 'ApplicationId');
        this.isLoading = true;
        this.viewApplicationService
        .fetchAcknowledgement(this.data?.registrationId, this.data?.applicationId)
        .subscribe(async ({status, data, errorMessage}) => {
          this.isLoading = false;
          if(status === 'SUCCESS') {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Acknowledgement",
                fileName: "ACKNOWLEDGEMENT_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
              }
            });
            modal.present();
          }
          else {
            this.viewApplicationService.errorToast(errorMessage);
          }
        }, error => {
          this.isLoading = false;
          this.viewApplicationService.errorToast("Unable to fetch Acknowledgement");
        });
      }
      showEmdReceipt() {
        this.isLoading = true;
        this.viewApplicationService
        .fetchEmdReceipt(this.data?.registrationId, this.data?.applicationId)
        .subscribe(async ({status, data, errorMessage}) => {
          this.isLoading = false;
          if(status === 'SUCCESS') {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "EMD Receipt",
                fileName: "EMD_RECEIPT_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
              }
            });
            modal.present();
          }
          else {
            this.viewApplicationService.errorToast(errorMessage);
          }
        }, error => {
          this.isLoading = false;
          this.viewApplicationService.errorToast("Unable to fetch EMD Receipt");
        });
      }

      showIntimationLetter() {
        this.isLoading = true;
        this.viewApplicationService
        .fetchLOI(this.data?.registrationId, this.data?.applicationNo)
        .subscribe(async ({status, data, errorMessage}) => {
          this.isLoading = false;
          if(status === 'SUCCESS') {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Intimation Letter",
                fileName: "INTIMATION_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
              }
            });
            modal.present();
          }
          else {
            this.viewApplicationService.errorToast(errorMessage);
          }
        }, error => {
          this.isLoading = false;
          this.viewApplicationService.errorToast("Unable to fetch LOI");
        });
      }

      showPol() {
        this.isLoading = true;
        this.viewApplicationService
        .fetchPOL(this.data?.registrationId, this.data?.applicationId)
        .subscribe(async ({status, data, errorMessage}) => {
          this.isLoading = false;
          if(status === 'SUCCESS') {
            const modal = await this.modalCtrl.create({
              component: ViewPdfComponent,
              componentProps: {
                base64: data,
                documentName: "Provisional Offer Letter (POL)",
                fileName: "PROVISIONAL_OFFER_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
              }
            });
            modal.present();
          }
          else {
            this.viewApplicationService.errorToast(errorMessage);
          }
        }, error => {
          this.isLoading = false;
          this.viewApplicationService.errorToast("Unable to fetch POL");
        });
      }

      //showNoc
showNoc() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchNOC(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "NOC",
          fileName: "NOC_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch NOC");
  });
}

//showAllotment
showAllotment() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAllotmentLetter(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Allotment Letter",
          fileName: "ALLOTMENT_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Allotment");
  });
}

showPossession() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchPossessionLetter(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Possession Letter",
          fileName: "POSSESSION_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Possession");
  });
}
showeSign() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchESign(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "E-Sign",
          fileName: "eSign"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch E-Sign");
  });
}
showAffidavit() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAffidavit(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Affidavit",
          fileName: "affidavit"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Affidavit");
  });
}
showPossessionsreceipt() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchPossessionsreceipt(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Possessions-receipt",
          fileName: "possessionsreceipt"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Possessions-receipt");
  });
}

showKeyhandoverphoto() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchKeyhandoverphoto(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewImageOnlyComponent,
        componentProps: {
          base64: data,
          documentName: "Keyhandoverphoto",
          fileName: "keyhandoverphoto"+this.data?.registrationId+"_"+new Date().getTime()+".jpeg"
        }
      });
      modal.present();
      // this.viewFile(data);
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Keyhandoverphoto");
  });
}

async viewFile(data) {
  console.log("File ka data", data);

  const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
    disableClose: true,
    panelClass: "progressSpinner",
  });
  const imageUrls = await Promise.all(
    data.split(",").map(async (imageData) => {
      if (imageData) {
        console.log("imageData", imageData);

        const response = await this.proApproverService
          .downloadFile(imageData)
          .toPromise();
        if (response != null && !response.error) {
          const binary = new Uint8Array(response);
          const url =
            "data:image/jpg;base64," +
            btoa(String.fromCharCode.apply(null, binary));
          return this.domSanitizer.bypassSecurityTrustUrl(url);
        }
      }
      return null;
    })
  );
  
  const [imageUrl, imageBackUrl] = imageUrls;
  progressSpinnerDialog.close();
  const dialogRef = this.dialog.open(ViewImageComponent, {
    disableClose: false,
    width: "600px",
    data: [imageUrl, imageBackUrl],
  });
  dialogRef.afterOpened().subscribe(() => {
    setTimeout(() => {}, 100);
  });
}

showApplicationsESign() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchApplicationsESign(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: " Application E-Sign",
          fileName: "Application_eSign"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch E-Sign");
  });
}

showeAcceptanceletter() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAcceptance(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Acceptance Letter",
          fileName: "ACCEPTANCE_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Acceptance Letter");
  });
}

showeSurrenderLetter() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchSurrender(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Surrender Letter",
          fileName: "SURRENDER_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Surrender Letter");
  });
}




async presentActionSheet(document: any) {
  let canCasteValidityBeEdited = false;
  if (document.qsCode == "Q_CAST_VALID") {
    if (this.documents[15]["qsCode"] == "Q_CASTE" && this.documents[15]["qs_ans"] != "OPEN") {
      canCasteValidityBeEdited = true;
    }
  }
  let actionSheetOptions: any[] = [];
  if (
    document.pkQsid == "4" ||
    document.pkQsid == "6" ||
    document.pkQsid == "9" ||
    document.pkQsid == "12" ||
    document.pkQsid == "14" ||
    document.pkQsid == "17" ||
    document.pkQsid == "18" ||
    document.pkQsid == "19" ||
    document.pkQsid == "20" ||
    document.pkQsid == "21" ||
    document.pkQsid == "22" ||
    document.pkQsid == "23" ||
    document.pkQsid == "25" ||
    document.pkQsid == "26" ||
    document.pkQsid == "31" ||
    canCasteValidityBeEdited ||
    (document.qs_ans_status != "Not Applicable" &&
      (document.pkQsid == "10" ||
        document.pkQsid == "11" ||
        document.pkQsid == "28" ||
        document.pkQsid == "29" ||
        document.pkQsid == "30"))
  ) {
    actionSheetOptions = [
      {
        cssClass: "first-button",
        text: this.viewEnMr,
        icon: "eye",
        data: 10,
        handler: () => {
          this.viewDocument(document);
        },
      },
      {
        text: this.editEnMr,
        icon: "create",
        data: "Data value",
        handler: () => {
          this.editRecord(document);
        },
      },
      {
        cssClass: "last-button",
        text: this.cancelEnMr,
        icon: "close",
        role: "cancel",
        handler: () => {
          // console.log('Cancel clicked');
        },
      },
    ];
  } else {
    actionSheetOptions = [
      {
        cssClass: "first-button",
        text: this.viewEnMr,
        icon: "eye",
        data: 10,
        handler: () => {
          this.viewDocument(document);
        },
      },
      // {
      //   text: this.editEnMr,
      //   icon: "create",
      //   data: "Data value",
      //   handler: () => {
      //     this.editRecord(document);
      //   },
      // },
      {
        cssClass: "last-button",
        text: this.cancelEnMr,
        icon: "close",
        role: "cancel",
        handler: () => {
          // console.log('Cancel clicked');
        },
      },
    ];
  }
  let status = document.qs_ans_status != null ? document.qs_ans_status : "-";
  const actionSheet = await this.actionSheetController.create({
    header: document.qsProfileDescription[this.activeLang] + " - ( " + status + " )",
    cssClass: "my-custom-class",
    buttons: actionSheetOptions,
  });
  await actionSheet.present();

  const { role, data } = await actionSheet.onDidDismiss();
  // console.log('onDidDismiss resolved with role and data', role, data);
}

async viewDocument(document) {
  console.log(document);

  if (document.qs_doc_document != "" && document.qs_doc_document != null && document.qs_doc_document != "-") {
    const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    let imageBackUrl = null;
    let image = document.qs_doc_document.split(",");
    console.log(image);

    if (image[1] != undefined) {
      await this.auditTrailService.downloadFileV1(image[1].split("/").pop(), this.data?.registrationId.toString()).subscribe((response: any) => {
        progressSpinnerDialog.close();
        if (response != null && !response.error) {
          // let file = new Blob([response], { type: "image/*" });
          // var fileURL = URL.createObjectURL(file);
          // imageBackUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
          var binary = "";
          var bytes = new Uint8Array(response);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let url = window.btoa(binary);
          let fileURL = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

          // let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
          imageBackUrl = fileURL;
          console.log(imageBackUrl);
        } else {
          progressSpinnerDialog.close();
          // this.errorToast();
        }
      });
    }
    await this.auditTrailService.downloadFileV1(image[0].split("/").pop(), this.data?.registrationId.toString()).subscribe((response: any) => {
      progressSpinnerDialog.close();
      console.log(response);

      if (response != null && !response.error) {
        let file = new Blob([response], { type: "image/*" });
        var fileURL = URL.createObjectURL(file);

        setTimeout(() => {
          var binary = "";
          var bytes = new Uint8Array(response);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let url = window.btoa(binary);
          let fileURL = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

          // let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
          let imageUrl = fileURL;
          console.log(fileURL);
          this.progressSpinnerDialog = this.dialog.open(ViewProfileDocumentComponent, {
            disableClose: false,
            width: "600px",
            data: [document.qsProfileDescription, document.qs_ans_status, imageUrl, imageBackUrl],
          });
        }, 100);
      } else {
        progressSpinnerDialog.close();
        // this.errorToast();
      }
    });
  } else {
    // this.warningToast();
  }
}

editRecord(document: any) {
  localStorage.setItem("isEdit", "true");
  localStorage.setItem("pkQsid", document.pkQsid);
  this.router.navigate(["/question-answer"]);
}

onSubmit(applicationNo: number,type: string, base64: string | ArrayBuffer) {
  console.log("On submit Callled")
  this.isLoading = true;
  this.submitDisabled = true;
  this.documentVerificationService.importLetter(
      this.applicationNo, type,base64
      ).subscribe((data: any) => {
        this.isSubmitDisabled = false;
        this.loadData();

        
        if(data.status === 'SUCCESS') {
          this.successMessage = "Successfully imported File";
          this.localForm.resetForm({
            lotteryKey: "",
            importMasterType: "",
            file: null
          });
          this.selectedFile = null;
          this.documentVerificationService.successToast("Successfully imported File");
          this.loaded = true;
          this.loadData();
        }
        else {
          this.loadData();
          this.selectedFile = null;
          this.errorMessage = "Failed to import, Please check error file.";
          this.errorFile = data.errorFile;
          this.loaded = true;
        }
      }, error => {
        this.localForm.resetForm({
          lotteryKey: "",
          importMasterType: "",
          file: null
        });
        this.selectedFile = null;
        this.isSubmitDisabled = false;
        console.log(error);
        this.documentVerificationService.errorToast(error?.error?.message||error?.error?.errorMessage, 5*1000);
        this.loaded = true;
      });        
}

downloadLetters() {

  if(this.data?.applicationNo !==null ){
    console.log(this.data?.applicationNo);
    this.auditTrailService.downloadLetters(this.data?.applicationNo)
    .subscribe((data) => {
      this.isLoading = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadedBatches.push(this.data?.applicationNo);
        this.downloadFile(data.base64File, data.fileName);
        this.successToast();
      }
      else {
        this.viewApplicationService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.viewApplicationService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

    });

  } else {
    this.viewApplicationService.errorToast("Please Enter Application Number");  
  }

  
}

downloadFile(base64:string | ArrayBuffer, fileName:string){
  const src = `${base64}`;
  const link = document.createElement("a")
  link.href = src
  link.download = fileName
  link.click()
  
  link.remove()
}
async successToast() {
  await this._snackBar.open(
      " Letters Successfully Downloaded",
      "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
      }
  );
}
showAgreement() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchAgreementCopy(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Agreement Letter",
          fileName: "AGREEMENT_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Agreement");
  });
}

showIndex2() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchIndex2(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "Index2 Letter",
          fileName: "INDEX2_LETTER_"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Index2");
  });
}


pageChanged(event: PageEvent) {
  console.log({ event });
  this.pageSize = event.pageSize;
  this.currentPage = event.pageIndex;
  this.loadData();
}

 possisionComplete() {

   if(this.data?.applicationNo !==null ){
     console.log(this.data?.applicationNo,"possisionCompleteCalled");
     this.documentVerificationService.updatePossession(this.data?.applicationNo)
    .subscribe((data) => {
       this.isLoading = false;
       this.isLoading = false;
       this.loadData();
     }, error => {
       this.isLoading = false;
       this.documentVerificationService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
       // this.exportImportService.errorToast("Please Enter Application Number:"+this.form.value.applicationNo);

     });

   } else {
     this.viewApplicationService.errorToast("Please Enter Application Number");  
   }

  
 }

 generetePossessionReceipt(){

  console.log('Button Call');
  console.log(this.data);
  console.log(this.data.applicationNo);
  this.isLoading = false;

  if(this.data.showPossession === 'Y'){
    this.viewApplicationService.generetePossessionReceipt(this.data.applicationNo)
    .subscribe((data) => {
      console.log("Data get after letter generate", data);
      if(data.status === 'SUCCESS') {
        console.log("Possession Receipt Generated Successfully.");
        this.downloadFile(data.base64File, data.fileName);
        this.ngOnInit();
        this.isLoading = false;
      }
      else {
        this.viewApplicationService.errorToast(data.errorMessage);
        this.isLoading = false;
      }
    }, error => {
      this.viewApplicationService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      this.isLoading = false;
    });
  }else{
    this.viewApplicationService.errorToast("Applicant Possession Letter is not published");
    this.isLoading = false;
  }


  
}

//showAllotment
showPossessionReceiptFormat() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchPossessionReceiptFormat(this.data?.registrationId, this.data?.applicationNo)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "POSSESSIONS RECEIPT FORMAT",
          fileName: "POSSESSIONS_RECEIPT_FORMAT"+this.data?.applicationNo+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch POSSESSIONS RECEIPT FORMAT");
  });
}

showCaseData() {
  this.isLoading = true;
  this.viewApplicationService
  .fetchCaseDatas(this.data?.registrationId, this.data?.applicationId)
  .subscribe(async ({status, data, errorMessage}) => {
    this.isLoading = false;
    if(status === 'SUCCESS') {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: data,
          documentName: "All Letter",
          fileName: "ALL_LETTERS"+this.data?.registrationId+"_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.viewApplicationService.errorToast(errorMessage);
    }
  }, error => {
    this.isLoading = false;
    this.viewApplicationService.errorToast("Unable to fetch Case File ");
  });
}

}

